import { DOCUMENT_TYPES, type DocumentType } from '../types/documentTemplates.types';

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  welcome_letter: 'Welcome letter',
  plan_certificate: 'Plan certificate',
  cancellation_confirmation: 'Cancellation confirmation',
  renewal_notice: 'Renewal notice',
  general: 'General',
};

export const DOCUMENT_TYPE_OPTIONS = DOCUMENT_TYPES.map((value) => ({
  value,
  label: DOCUMENT_TYPE_LABELS[value],
}));
